<template>
  <div class="daily-exercise">
    <div class="section-header">
      <h1 v-if="!viewAll">My habits to do today</h1>
      <h1 v-else>All my habits</h1>
      <div class="align-center">
        <i class="material-icons clickable" @click="display=true">add</i>
        <h-icon class="clickable" @click="viewAll=!viewAll">list</h-icon>
      </div>
    </div>
    <div class="row flex-wrap">
      <div v-if="!viewAll" class="row flex-wrap full-width">
        <exercise 
          v-for="exercise in myHabits" 
          :key="exercise.id" 
          :exercise="exercise" 
          @completed="completed(exercise)" 
          @delete="ignoreExercise(exercise)"
          @remove="removeFromLists(exercise)" 
          />
      </div>
      <div class="card card--transparent" v-if="myHabits.length === 0 && !viewAll" >
        <div class="container">
          Looks like you've completed all your Habits for the day! 
        </div>
      </div>
      <all-client-habits v-if="viewAll" :bus="bus" />
    </div>
    <div class="section-header">
      <h1>Recommended Habits</h1>
      <i class="material-icons clickable" @click="requestNew">add</i>
    </div>
    <div class="row flex-wrap">
      <exercise 
        v-for="exercise in recommendedHabits"
        :key="exercise.id" 
        :exercise="exercise" 
        :editable="false"
        @completed="completed(exercise)"
        @delete="ignoreExercise(exercise)" />
    </div>
    <habit-modal v-if="display" @close="display=false" :habit="habit" @save="newHabit" />
  </div>
</template>

<script>
import exercise from "./exercise";
import habitModal from "./habitModal";
import dataStore from "@/services/api/store";
import moment from "moment";
import store from "@/services/api/store";
import snackbar from "@/services/hubs/snackbar";
import modal from "@/components/modal";
import allClientHabits from "./allClientHabits";
import Vue from "vue";

const CLIENT_STORE = "ClientHabits";

export default {
  components: { exercise, habitModal, modal, allClientHabits },
  data() {
    return {
      display: false,
      myHabits: [],
      recommendedHabits: [],
      habit: {},
      viewAll: false,
      bus: new Vue()
    };
  },
  created() {
    this.init();
    dataStore
      .findAll("ClientTasks", { due: true }, { force: true })
      .then(results => {
        results.forEach(e => {
          e.dueIn = moment(e.due_at).fromNow()
        })
        this.myHabits = results.filter(exercise => exercise.template === null);
        this.recommendedHabits = results.filter(exercise => exercise.template !== null);
      });
  },
  methods: {
    requestNew() {
      dataStore.create("ClientTasks").then(task => {
        this.recommendedHabits = [task, ...this.recommendedHabits];
      });
    },
    init() {
      this.habit = {
        days_of_week: [],
        color: "",
        time: "12:00:00"
      };
    },
    completed(e) {
      this.removeFromLists(e);
    },
    removeFromLists(e) {
      this.myHabits = this.myHabits.filter(exercise => exercise.id !== e.id);
      this.recommendedHabits = this.recommendedHabits.filter(exercise => exercise.id !== e.id);
    },
    newHabit() {
      store.create(CLIENT_STORE, this.habit).then(r => {
        this.init();
        this.bus.$emit("newHabit", r);
        snackbar.update("Saved");
        this.display = false;
      });
    },
    ignoreExercise(exercise) {
      exercise.ignored = true;
      exercise.save();
      snackbar.update("Exercise deleted");
      this.removeFromLists(exercise);
    }
  }
};
</script>

<style lang="less" scoped>

</style>
